import {
	ACCESS_RIGHT_AREAS,
	ACCESS_RIGHT_TYPES,
} from "../../../constant/permissions";
import { createActionColumn } from "../../../utils/grid-columns";
import { getFormattedDate } from "../../../utils/method";

export const getTemplateTableColumns = (t, onEdit, onDelete) => [
	{
		headerName: t("templates.created-at"),
		field: "createdAt",
		flex: 1.5,
		minWidth: 150,
		cellRenderer: (params) => {
			return getFormattedDate(params.value);
		},
	},
	{
		headerName: t("templates.template-name"),
		field: "name",
		flex: 2,
		minWidth: 200,
	},
	createActionColumn({
		t,
		actions: [
			{
				permission: {
					area: ACCESS_RIGHT_AREAS.TEMPLATE,
					action: ACCESS_RIGHT_TYPES.EDIT,
				},
				onClick: onEdit,
				label: "help.action-edit",
			},
			{
				permission: {
					area: ACCESS_RIGHT_AREAS.TEMPLATE,
					action: ACCESS_RIGHT_TYPES.DELETE,
				},
				onClick: onDelete,
				label: "help.action-delete",
				danger: true,
			},
		],
	}),
];
